/**
 * Browser- und serverneutrale Konstanten der OpenAI-Ads-Messung.
 * Pixel-ID des aktiven Conversion-Ziels "Lead Created".
 */
export const OAIQ_PIXEL_ID = "6SL7rt2tu5HDJq8srqGrGw";
